(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('cgexception', function () {
      var knownExceptions = [
        'ERestField',
        'ECGException',
        'EObjLock',
        'EJsonWrite',
        'ERestNotFound',
        'ELicenceLimit',
        'EEDEPTONotFound',
        'ESearchParserFieldNotFound',
        'EObjContabilidade',
        'EEPOCNotFound',
        'EPolAcesso',
        'EEntity'
      ];

      var factory = {
        knownExceptions: knownExceptions,
        isFatal: isFatal,
        get: get
      };
      return factory;

      /////////////

      function isFatal(className) {
        return factory.knownExceptions.indexOf(className) === -1;
      }

      function get(data) {
        var error = {
          class: 'unknown',
          message: 'error #' + data.status,
          fields: []
        };
        var exception;
        if (data) {
          exception = data.headers('exception');
        }
        if (exception) {
          exception = angular.fromJson(exception);
          error = {
            class: exception.exception.class,
            message: exception.exception.message,
            status: exception.exception.status,
            fields: []
          };
        }
        else {
          exception = {
            exception: {
              class: 'unknown',
              message: 'error #' + data.status,
              fields: []
            }
          };
          error = exception.exception;
        }

        if (data.status === 400 || data.status === 404 || (data.status === 500 && !factory.isFatal(exception.exception.class))) {
          if (exception && exception.exception && exception.exception.fields) {
            for (var i = 0; i < exception.exception.fields.length; i++) {
              error.fields.push(exception.exception.fields[i]);
            }
          }
          else {
            error.message = exception.exception.message;
            error.class = exception.exception.class;
          }
          return error;
        }
        else {
          return error;
        }
      }
    });
})();
